export const SUBSCRIPTION_LIMITS = {
  trial: {
    slides: 20,
    "api-credits-limit": 10,
  },
  starter: {
    "export-pdf": true,
    "live-stories": 5,
    "stories-folders-limit": 2,
    "live-versions": 10,
    "version-og-image-limit": 3,
    "settings-storydoc-branding": true,
    "api-credits-limit": 10,
    "ai-limitation": {
      text: 25,
      image: 20,
      video: 3,
      translation: 1,
      brandfetch: 10,
    },
    elements: {
      charts: {
        "horizontal-stacked": true,
        "vertical-stacked": true,
        "horizontal-area": true,
        "vertical-area": true,
        "horizontal-smooth-line": true,
        "vertical-smooth-line": true,
        "horizontal-smooth-area": true,
        "vertical-smooth-area": true,
        "horizontal-scatter": true,
        "bar-line": true,
      },
    },
    "elements-library": {
      videos: {
        Up1RHJJah4yZreBEtw8k: true,
        QOwdSoTzrTj9bp7UZoyN: true,
        uTZUVscKTU7w9qaooZUl: true,
      },
      calendars: {
        SKT5SxJpRN1sgMJMvKhx: true,
        zcYidrAL43r33j7gExwf: true,
        SSBVfVpPsQ3wxQoTBzrB: true,
        ovSNT3WNTTmeBTG5J2Rc: true,
        kG9hlJ5tOg27Y4HiOJC8: true,
        uZbQwcKTwE19ELoXyjbB: true,
        xGUpkYBuMWC6KWKRSl38: true,
        mUyDBpIeKBPBn01pxLga3: true,
      },
      "embedded tools": {
        HqhXA6kVvsg7UmkDu4Vq: true,
        kdJcKNU5FLl3nbJaInZL: true,
        lAqbfi3ENotrPCjPL6pG: true,
        cXPL9fjyc2ORq0DCq2EH: true,
      },
      charts: {
        vKqZNSDh7MMTqY3rcp7h: true,
        AyPh4aavoiHihqA9gFs2: true,
        no7VSkpevoJ88qHjQOMc: true,
        x0MGzqRGTvxOh0ULEyP3: true,
      },
      "media grids": {
        hJsrRDjdxuvoZyxKFllk: true,
        YmqOfOSsTHZ5WVCMBJsW: true,
        FWyxC8nYR0gPFJ2DEF2N: true,
      },
    },
  },
  pro: {
    // Send flow (Figma 'Limitations', orange = Pro): available from Pro.
    "send-auto-reminders": true,
    "bulk-create": true,
    // The version builder's "+" import (Figma 229:370651).
    "version-builder-import": true,
    "request-reader-details": true,
    "downloadable-pdf": true,
    "settings-default-theme": true,
    "ai-limitation": {
      text: 200,
      image: 50,
      video: 10,
      translation: 100,
      brandfetch: 999,
    },
    "bulk-send": 50,
    "stories-folders-limit": 10,
    "settings-menu": true,
    "settings-watermark": true,
    "design-system-save-to-library": true,
    "design-system-import-design": true,
    "version-access-control": true,
    "version-expiry-date": true,
    "chart-upload-csv": true,
    "create-custom-variables": true,
    "create-profile-custom-fields": true,
    "file-history": true,
    "change-favicon": true,
    "account-customization-logo": true,
    "api-credits-limit": 25,
    "version-share-option": {
      embed: true,
    },
    elements: {
      videos: {
        vidyard: true,
        loom: true,
        vimeo: true,
      },
      embedded: {
        code: true,
      },
      calendars: {
        hubspot: true,
        mixmax: true,
        chillipiper: true,
        "sales-loft": true,
        "outreach-io": true,
        yesware: true,
        front: true,
        custom: true,
      },
      grids: {
        "grid-4": true,
        "grid-7": true,
        "grid-8": true,
      },
      forms: {
        hubspot: true,
        custom: true,
      },
    },
    "elements-library": {
      "seal the deal": {
        FJO4ZjTi33Llf1Ni6G9iy: true,
        E3EtcAij94tifyqnFmZqo: true,
        Syufgbb4ZiMiCp0mw4Pao: true,
      },
    },
    "marketing-integrations": {
      "google-tag-manager": true,
      "meta-pixel": true,
      "linkedin-insight-tag": true,
      "hotjar-tracking-script": true,
      "crazy-egg-tracking-script": true,
      "bing-ads-uet-tag": true,
      "google-ads-remarketing-tag": true,
      "marketing-integrations": true,
    },
  },
  team: {
    // Send flow (Figma 450:43648): emails from the org's own domain.
    "sending-domain": true,
    "reader-details-custom-fields": true,
    "generate-gif-preview": true,
    "bulk-send": 500,
    "save-as-team-slide": true,
    "version-password-protection": true,
    "version-downloadable-pdf": true,
    "stories-folders-members-edit": true,
    "editor-dynamic-variables": true,
    "custom-dynamic-variables": true,
    "api-credits-limit": 100,
    "user-role-type": true,
    "creator-lite-role-type": true,
    "custom-subdomain": true,
    "whitelabel-domain": true,
    "team-members": {
      administrator: true,
      creator: true,
      "creator lite": true,
      user: true,
    },
    "marketing-integrations": {
      "marketo-tracking-code": true,
      "segment-embed-code": true,
      "hubspot-tracking-script": true,
      "adobe-analytics-tag": true,
      "salesforce-marketing-cloud": true,
      "zoho-tracking-code": true,
    },
    "crm-integrations": {
      hubspot: true,
      gong: true,
      salesforce: true,
      zapier: true,
      pipedrive: true,
      salesloft: true,
      outreach: true,
      zoho: true,
      marketo: true,
    },
    "ai-limitation": {
      text: 10000,
      image: 10000,
      video: 50,
      translation: 10000,
      brandfetch: 10000,
    },
  },
};
